import Vue from 'vue'
import Router from 'vue-router'
import Login from './Login.vue'
import Registration from './Registration.vue'
import NewPassword from './NewPassword.vue'
import PasswordReset from './PasswordReset.vue'
import Layout from './Layout.vue'
import Profile from './views/Profile.vue'
import Applications from './views/Applications.vue'
import Application from './views/Application.vue'
import NewApplication from './views/NewApplication.vue'
import Competitors from './views/Competitors.vue'
import Competitor from './views/Competitor.vue'
import Race from './views/Race.vue'
import Run from './views/Run.vue'
import Server from './views/Server.vue'
import Contact from './views/Contact.vue'
import Competition from './views/Competition.vue'
import Referee from './views/Referee.vue'
import Dashboard from './views/Dashboard.vue'
import ResultsPage from './ResultsPage.vue'
import Results from './views/Results.vue'
import ApplicationsPage from './ApplicationsPage.vue'
import store from './store';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/app'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/registration',
      name: "registration",
      component: Registration
    },
    {
      path: '/password-reset',
      name: "password-reset",
      component: PasswordReset
    },
    {
      path: '/new-password',
      name: "new-password",
      component: NewPassword
    },
    {
      path: '/results',
      component: ResultsPage
    },
    {
      path: '/applications',
      component: ApplicationsPage
    },
    {
      path: '/app',
      name: 'app',
      component: Layout,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'dashboard',
          component: Dashboard
        },
        {
          path: 'profile',
          component: Profile
        },
        {
          path: 'applications',
          component: Applications
        },
        {
          path: 'applications/new',
          name: 'new-application',
          component: NewApplication
        },
        {
          path: 'applications/:id',
          component: Application
        },
        {
          path: 'server',
          component: Server
        },
        {
          path: 'competitors',
          component: Competitors
        },
        {
          path: 'competitors/:id',
          component: Competitor
        },
        {
          path: 'competition',
          component: Competition
        },
        {
          path: 'referee',
          component: Referee
        },
        {
          path: 'races/:id',
          component: Race
        },
        {
          path: 'runs/:id',
          component: Run
        },
        {
          path: 'contact',
          component: Contact
        },
        {
          path: 'results',
          component: Results
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters['isAuthenticated']) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    }
  }
  next(); // make sure to always call next()!
});

export default router;